import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { labelsByRoomType } from 'src/consts';
import { getCurrentRoom } from 'src/store/rooms/selectors';

export const RoomBookingSidesheetTitle: FC = () => {
  const room = useSelector(getCurrentRoom);

  const title = useMemo((): string => {
    return room?.title && room.roomType
      ? `${labelsByRoomType[room.roomType]} ${room.title}`
      : 'Объект бронирования';
  }, [room?.roomType, room?.title]);

  return room ? (
    <Typography ellipsis variant='h5' data-testid='bookingSideSheetTitle'>
      {title}
    </Typography>
  ) : null;
};
